export default [
    {
        path: "/auth/signin",
        name: "signin",
        component: () => import("../views/auth/signin.vue"),
        meta: {
            title: "Login",
            /*beforeResolve(routeTo, routeFrom, next) {
                console.log({routeTo, routeFrom, next})
                console.log(" USER ", store.getters["auth/loggedIn"])
                // If the user is already logged in
                if (store.getters["auth/loggedIn"]) {
                    // Redirect to the home page instead
                    next({name: "default"});
                    next();
                } else {
                    // Continue to the login page
                    next();
                }
            },*/
        },
    },
    {
        path: "/register",
        name: "Register",
        component: () => import("../views/registration/supplier-registration.vue"),
        meta: {
            title: "Register",
            authRequired: false
            // beforeResolve(routeTo, routeFrom, next) {
            //     // If the user is already logged in
            //     if (store.getters["auth/loggedIn"]) {
            //         // Redirect to the home page instead
            //         next({name: "default"});
            //     } else {
            //         // Continue to the login page
            //         next();
            //     }
            // },
        },
    },
    {
        path: "/forgot-password",
        name: "Forgot password",
        component: () => import("../views/account/forgot-password.vue"),
        meta: {
            title: "Forgot Password",
            // beforeResolve(routeTo, routeFrom, next) {
            //     // If the user is already logged in
            //     if (store.getters["auth/loggedIn"]) {
            //         // Redirect to the home page instead
            //         next({name: "default"});
            //     } else {
            //         // Continue to the login page
            //         next();
            //     }
            // },
        },
    },
    {
        path: "/reset-password",
        name: "Reset password",
        component: () => import("../views/account/reset-password.vue"),
        meta: {
            title: "Reset Password",
            // beforeResolve(routeTo, routeFrom, next) {
            //     // If the user is already logged in
            //     if (store.getters["auth/loggedIn"]) {
            //         // Redirect to the home page instead
            //         next({name: "default"});
            //     } else {
            //         // Continue to the login page
            //         next();
            //     }
            // },
        },
    },
    {
        path: "/account/profile",
        name: "profile",
        meta: {title: "Profile", authRequired: true, privileges: ['SUPPLIER_MANAGE_PROFILE']},
        component: () => import("../views/account/profile"),
    },
    {
        path: "/account/supplier-status",
        name: "supplier-status",
        meta: {title: "Supplier Account Status", authRequired: true, privileges: ['SUPPLIER_VIEW_ACCOUNT']},
        component: () => import("../views/account/supplier-status.vue"),
    },


]
